function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 25C19.404 25 25 19.404 25 12.5S19.404 0 12.5 0 0 5.596 0 12.5 5.596 25 12.5 25z",
  fill: "url(#noimage_svg__paint0_linear)"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.751 14.145h-2.978L10.103 16h-.966l2.715-7.11h.82l2.72 7.11h-.962l-.679-1.855zm-2.695-.772h2.417l-1.211-3.325-1.206 3.325z",
  fill: "#17171A"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "noimage_svg__paint0_linear",
  x1: 36.962,
  y1: -13.188,
  x2: -11.69,
  y2: 40.138,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D8D8D8"
})));

function SvgNoimage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    style: {
      margin: "0 7px"
    }
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "452bbbcb6a4f7c12815bd8277176899b.svg";
export { SvgNoimage as ReactComponent };